module.exports = __webpack_public_path__ + "media/lpq_16x9.43221499.mp4";